export default {
  init() {
	// js to fire on contact-us page
  },

};



// WEBPACK FOOTER //
// ./scripts/routes/contact-us.js